import { Box, Paper } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";

import MedlyLogoFooter from "@/assets/images/medly-logo-footer.png";

interface AuthCardProps {
  children: React.ReactNode;
  width?: number;
  gap?: number;
  sx?: SxProps<Theme>;
}

export const AuthCard = ({ children, width = 394, gap = 2, sx }: AuthCardProps) => {
  return (
    <Paper
      elevation={3}
      sx={{
        maxWidth: width,
        width,
        paddingTop: 4,
        px: 2,
        paddingBottom: 3,
        borderRadius: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap,
        ...sx,
      }}
    >
      <Box component="img" src={MedlyLogoFooter} alt="Medly" height={48} width="auto" />
      {children}
    </Paper>
  );
};
